import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgConfusedEmojiSecondary from './svgs/ConfusedEmojiSecondary.js';
import SvgConfusedEmoji from './svgs/ConfusedEmoji.js';
import { useIcon } from '../../shared-components/icon/index.js';

var confusedEmoji = (props => useIcon(SvgConfusedEmoji, SvgConfusedEmojiSecondary, props));

export { confusedEmoji as default };
